'use strict';
module.exports = function setElementVisibility(element, visible) {

	if (element) {
		if (visible) {
			element.style.display = '';
		} else {
			element.style.display = 'none';
		}
	}
	return element;
};
